import React from "react";
import { ModalPadrao } from "./Base";
import { QRCode } from "antd";
import { BtnCancelar } from "./Buttons";

export default function ModalQrCode({ visible, qrCode, onCancel, loading }) {

  return <ModalPadrao title="Aproxime a câmera do seu dispositivo" visible={visible} closable={false} footer={<BtnCancelar loading={loading} onClick={() => onCancel()} />}>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <QRCode color="white" value={qrCode} />
    </div>
  </ModalPadrao>;
}